import React from 'react'
import img from '../../assets/about.png'
import { SiTicktick } from 'react-icons/si'
import { FaWhatsapp } from 'react-icons/fa6'
import { IoMailOutline } from 'react-icons/io5'
import { Link } from 'react-router-dom'

const About = () => {
  return (
    <div id='about' className="gradul md:py-12 py-8 mt-8 ">
        <div className='max-w-[1400px] 2xl:mx-auto mx-4 md:my-[80px] my-[25px] rounded-lg'>
      <div className='md:flex justify-between items-center'>
        <div className=''>
            <span className='text-darklight '>About me</span>
            <h1 className='text-light md:text-5xl text-4xl font-semibold my-2'>Professional <span className='text-secondary'>Problem Solutions</span></h1>
            <h1 className='text-light md:text-5xl text-4xl font-semibold'>For Websites</h1>
            <p className='md:w-[720px] text-darklight mt-6'>I am a passionate Web Designer and Web Developer with over 3 years of experience, specializing in crafting dynamic, responsive, and user-focused websites. My expertise spans all stages of the development lifecycle, from initial concept and wireframing to final deployment and optimization.</p>
            <p className='md:w-[720px] text-darklight my-2'>I pride myself on delivering clean, modern designs and efficient, scalable code that enhances user engagement and achieves business goals. Beyond development, I stay updated with the latest trends and technologies to ensure my projects are innovative and ahead of the curve.</p>
            <div className='flex items-center gap-16 my-6 text-lg font-semibold'>
                <div className="flex items-center gap-3">
                    <SiTicktick className='text-secondary'/> Web Designing
                </div>
                <div className="flex items-center gap-3">
                    <SiTicktick className='text-secondary'/> Web Development
                </div>
            </div>
            <div className='flex items-center gap-16 my-6 text-lg font-semibold'>
                <div className="flex items-center gap-3">
                    <SiTicktick className='text-secondary'/> Thumbnail Designing
                </div>
                <div className="flex items-center gap-3">
                    <SiTicktick className='text-secondary'/> Problem Solving
                </div>
            </div>
            <div className='bg-secondary p-4 rounded-xl md:flex items-center gap-6 mt-12'>
                <div className='flex gap-3 items-center'>
                    <div className='grad p-3 rounded-full text-2xl'><IoMailOutline /></div>
                    <Link to="mailto:contact@mabubakaransari.com" target='_blank'>
                        <span className='font-bold'>Email</span>
                        <p>contact@mabubakaransari.com</p>
                    </Link>
                </div>
                <div className='flex gap-3 items-center md:my-0 my-6'>
                    <div className='grad p-3 rounded-full text-2xl'><FaWhatsapp  /></div>
                    <Link to="https://wa.me/+923116423558" target='_blank'>
                        <span className='font-bold'>Whatsapp</span>
                        <p>+92 3116423558</p>
                    </Link>
                </div>
            </div>
        </div>
        <div className='bg-secondary rounded-lg pt-4 md:w-[400px] md:mt-0 mt-8'><img className='rounded-lg' src={img} alt="" /></div>
      </div>
    </div>
    </div>
  )
}

export default About
